import "react";
function placementContextHandler(wsRef, realtimeContext) {
    const { requestFrom } = realtimeContext;
    switch(requestFrom){
        case 'travel-itinerary':
            const { offerToken, offerNumber, cguid, rguid, productId } = realtimeContext ?? {};
            wsRef.current.sendMessage({
                type: 'realtime_client_context',
                data: {
                    offerNumber,
                    offerToken,
                    requestFrom,
                    cguid,
                    rguid,
                    productId
                }
            });
            break;
        case 'hotelListingPage':
        case 'productListingPage':
            const { listingContext } = realtimeContext ?? {};
            if (listingContext?.hotelPayload?.availableHotelsOnListing?.length) wsRef.current.sendMessage({
                type: 'realtime_client_context',
                data: {
                    listingContext,
                    requestFrom
                }
            });
            break;
        case 'hotelDetailPage':
        case 'productDetailPage':
            const { detailsContext, hotelName } = realtimeContext ?? {};
            if (detailsContext) wsRef.current.sendMessage({
                type: 'realtime_client_context',
                data: {
                    detailsContext,
                    requestFrom,
                    hotelName
                }
            });
            break;
        case 'rcListingsPage':
            const { rcListingsContextStr } = realtimeContext ?? {};
            if (rcListingsContextStr) wsRef.current.sendMessage({
                type: 'realtime_client_context',
                data: {
                    rcListingsContextStr,
                    requestFrom
                }
            });
            break;
        default:
            break;
    }
}
export { placementContextHandler };
